/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ProcessingTimesConfigurationModelDto,
  ProductFeatureProcessingTimesModelDto,
  TimeZoneModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ProcessingTimesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ProcessingTimes
   * @name ProcessingTimesGet
   * @summary Gets FI processing time.
   * @request GET:/processingTimes
   */
  processingTimesGet = (params: RequestParams = {}) =>
    this.http.request<ProcessingTimesConfigurationModelDto, any>({
      path: `/processingTimes`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProcessingTimes
   * @name ProcessingTimesPut
   * @summary Updates FI processing time.
   * @request PUT:/processingTimes/{id}
   */
  processingTimesPut = (
    id: number,
    data: ProductFeatureProcessingTimesModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ProductFeatureProcessingTimesModelDto, any>({
      path: `/processingTimes/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProcessingTimes
   * @name ProcessingTimesGetById
   * @summary Gets processing time.
   * @request GET:/processingTimes/{id}
   */
  processingTimesGetById = (id: number, params: RequestParams = {}) =>
    this.http.request<ProductFeatureProcessingTimesModelDto, any>({
      path: `/processingTimes/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProcessingTimes
   * @name ProcessingTimesGetTimeZones
   * @summary Gets FI time zone.
   * @request GET:/processingTimes/timeZones
   */
  processingTimesGetTimeZones = (params: RequestParams = {}) =>
    this.http.request<any[], any>({
      path: `/processingTimes/timeZones`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ProcessingTimes
   * @name ProcessingTimesUpdateTimeZone
   * @summary Updates FI time zone information.
   * @request PUT:/ProcessingTimes/TimeZone
   */
  processingTimesUpdateTimeZone = (
    data: TimeZoneModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/ProcessingTimes/TimeZone`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
